export class LocationGroup {
  defaultVenueGroup;

  constructor(obj?: LocationGroup) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/location-groups/location-group.model.ts